import * as actionTypes from './actionsTypes';

export const setKeyPressEvent = (event) => {

  return {
    type: actionTypes.KEYPRESSEVENT,
    data: event,
  };
};
